var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var toEstimateRequest = function (params) {
    var points = params.points, payment = params.payment, requirements = params.requirements, 
    // если нет имени зоны, то и в эстимейт ходить не нужно
    // имя сбрасывается при смене зоны
    zoneName = params.zoneName;
    if (points && zoneName) {
        return __assign({ all_classes: true, requirements: requirements, selected_class: '', route: points }, payment && {
            payment: {
                type: payment.type,
                payment_method_id: payment.id || undefined,
            },
        });
    }
};
